import {queryOptions} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {SavedMealsDependencies} from '../dependencies';
import type {SavedMealId} from '../domain/saved-meal-id.value-object';
import {keys} from './keys';

export type GetSavedMealQueryDependencies = Pick<SavedMealsDependencies, 'controllers'>;

export const getSavedMealQuery = (
  {controllers}: GetSavedMealQueryDependencies,
  savedMealId: SavedMealId,
) =>
  queryOptions({
    queryKey: keys.detail(savedMealId),
    queryFn: () => controllers.savedMealController.getById(savedMealId).then(unwrap),
  });
